import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, RouterOutlet } from '@angular/router';
import { NavComponent } from './components/nav/nav.component';
import { FooterComponent } from './components/footer/footer.component';
import { CommonModule } from '@angular/common';
import { LangChangeEvent, TranslateModule } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogModule } from '@angular/cdk/dialog';
import { Dialog } from '@angular/cdk/dialog';
import { CookieConsentDialogComponent } from './components/cookie-consent-dialog/cookie-consent-dialog.component';

@Component({
  selector: 'app-root',
  standalone: true,
  providers: [],
  imports: [
    RouterOutlet,
    NavComponent,
    FooterComponent,
    CommonModule,
    TranslateModule,
    DialogModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'Omex';
  consent = localStorage.getItem('cookieConsent');
  ngOnInit() {
    if (this.consent === null) {
      const dialogRef = this.dialog.open(CookieConsentDialogComponent, {
        disableClose: true, // użytkownik nie może zamknąć klikając poza modalem
        backdropClass: 'cookie-backdrop',
      });
      dialogRef.closed.subscribe((result) => {
        localStorage.setItem('cookieConsent', result ? 'accepted' : 'declined');
      });
    }
  }

  onActive() {
    window.scroll(0, 0);
  }

  reciever(lang: string) {
    this.translate.use(lang);
  }

  languageCode: string = 'pl';

  constructor(public translate: TranslateService, private dialog: Dialog) {
    this.translate.setDefaultLang(this.languageCode);
    this.translate.use(this.languageCode);
  }
}
